import API, { apiErrorMessage } from "../global/api";

export const requestPasswordChange = () => {
  return {
    type: "REQUEST_CHANGE_PASSWORD",
  };
};
export const successPasswordChange = (data) => {
  return {
    type: "SUCCESS_CHANGE_PASSWORD",
    payload: data,
  };
};
export const errorPasswordChange = (msg) => {
  return {
    type: "ERROR_CHANGE_PASSWORD",
    payload: msg,
  };
};

export const changePassword = (
  data,
  handleVisible,
  handleDangerVisible,
  handleClosePasswordModal,
) => {
  return (dispatch) => {
    dispatch(requestPasswordChange());
    API.put(`/user/change-password`, data)
      .then((res) => {
        let changePasswordResponse = res.data;
        dispatch(successPasswordChange(changePasswordResponse));
        handleVisible(changePasswordResponse.message);
        handleClosePasswordModal();
      })
      .catch((error) => {
        handleDangerVisible(apiErrorMessage(error));
        dispatch(errorPasswordChange(apiErrorMessage(error)));
      });
  };
};

export const requestUserDetails = () => {
  return {
    type: "REQUEST_USER_DETAILS",
  };
};
export const successUserDetails = (data) => {
  return {
    type: "SUCCESS_USER_DETAILS",
    payload: data,
  };
};
export const errorUserDetails = (msg) => {
  return {
    type: "ERROR_USER_DETAILS",
    payload: msg,
  };
};

export const getUserDetails = () => {
  return (dispatch) => {
    dispatch(requestUserDetails());
    API.get(`/user/me`)
      .then((res) => {
        let userDetails = res.data;
        dispatch(successUserDetails(userDetails));
      })
      .catch((error) => {
        dispatch(errorUserDetails(apiErrorMessage(error)));
      });
  };
};

// From Add Invoice Screen
export const addingInvoiceForMeCall = () => {
  return {
    type: "ADDING_INVOICE",
  };
};
// From Add Invoice Screen
export const addingBulkInvoiceForMeCall = (data) => {
  return {
    type: "ADDING_BULK_INVOICE",
    payload: Number(data),
  };
};
// From Deleting Invoice Screen
export const deletingInvoiceForMeCall = (data) => {
  return {
    type: "DELETING_INVOICE",
    payload: Number(data),
  };
};
// From Add Company Screen
export const addingCompanyForMeCall = () => {
  return {
    type: "ADDING_COMPANY",
  };
};
// From Deleting Company Screen
export const deletingCompanyForMeCall = () => {
  return {
    type: "DELETING_COMPANY",
  };
};
